module.exports = __webpack_public_path__ + "img/電気回路_5_1.17224755.png";